import httpService from "./http.service";

class FormService {
    getUrl = "/form-questions";

    get = (sectionId) => {
        return httpService.get(this.getUrl + `/${sectionId}`);
    };
    create = (model) => {
        return httpService.post("/form-questions", model);
    };
    edit = (id, model) => {
        return httpService.patch("/form-questions/" + id, model);
    };
    delete = (id) => {
        return httpService.delete("/form-questions/" + id);
    };
}

const formService = new FormService();
export default formService;